import React, { Component } from 'react';
import jquery from 'jquery';

var Highcharts = require('highcharts');


class Category {
  constructor(id, number) {
    this.id = id;
    this.number = number;
  }

  toString() {
    return this.number;
  }
}

export class LastBuildChart extends Component {
  constructor(props) {
    super(props);
    this.state = { };
  }

  buildNumberUrl(buildId) {
    return window.location.pathname + "?ci=" + this.props.ci_system + "&subNumber=" + this.props.sub_number + "&buildId=" + buildId;
  }

  loadNewState(parentId, buildId) {
    var usedParentId = parentId === null ? buildId : parentId;
    const url = 'https://api.bob-bench.org/v1/branchSummary/' + usedParentId + '/' + buildId;
    jquery.getJSON(url).done(function(data) {
      var categories = [];
      var tests = [];
      var errors = [];
      var failures = [];
      var durations = [];

      data.forEach(function(stat) {
        categories.push(new Category(stat.id, stat.build_number));
        tests.push(stat.testCount === null ? 0 : stat.testCount);
        errors.push(stat.errorCount === null ? 0 : stat.errorCount);
        failures.push(stat.failureCount === null ? 0 : stat.failureCount);
        durations.push(stat.duration === null ? 0 : stat.duration / (1000 * 1000 * 1000));
      });
      // All share the same xAxis
      this.testsChart.xAxis[0].setCategories(categories, false);
      this.errorChart.xAxis[0].setCategories(categories, false);
      this.failChart.xAxis[0].setCategories(categories, false);
      this.timeChart.xAxis[0].setCategories(categories, false);

      this.testsChart.series[0].setData(tests, false);
      this.errorChart.series[0].setData(errors, false);
      this.failChart.series[0].setData(failures, false);
      this.timeChart.series[0].setData(durations, false);
      this.testsChart.redraw();
      this.errorChart.redraw();
      this.failChart.redraw();
      this.timeChart.redraw();
      this.setState({categories: categories});
    }.bind(this)).fail(function(error, a, b) {
    });
  }

  componentDidMount() {
    this.testsChart = this.createChart("Test count", "Tests", "tests", this.refs.testsChart);
    this.errorChart = this.createChart("Error count", "Errors", "errors", this.refs.errorChart);
    this.failChart = this.createChart("Failure count", "Failures", "failures", this.refs.failChart);
    this.timeChart = this.createChart("Build time", "Time", "seconds", this.refs.timeChart);
    this.loadNewState(this.props.parentId, this.props.buildId);
  }

  createChart(chartName, axis, unit, ref) {
    return new Highcharts['chart']({
      title: {
        text: chartName,
      },
      chart: {
        renderTo: ref
      },
      exporting: { enabled: true },
      xAxis: [{
        categories: [],
        crosshair: true,
        labels: {
            useHTML: true,
            formatter: function() {
                /* Capture the "this" so we can do this.props" */
                const that = this;
                return function() {
                    if (that.props.buildId === this.value.id)
                      return "<a href=\"" + that.buildNumberUrl(this.value.id) + "\"><b>" +
                              this.value.number + "</b></a>";
                    else
                      return "<a href=\"" + that.buildNumberUrl(this.value.id) + "\">" +
                              this.value.number + "</a>";

                }
            }.bind(this)(),
        }
      }],
      yAxis: [
        {
          title: {
            text: '',
            style: {
              color: Highcharts.getOptions().colors[2]
            }
          },
          labels: {
            format: '{value}',
            style: {
              color: Highcharts.getOptions().colors[2]
            }
          },
          min: 0.0,
          opposite: false
        },
      ],
      legend: {
        enabled: false
      },
      tooltip: {
        shared: true,
      },
      series: [
        {
          name: axis,
          type: 'spline',
          dashStyle: 'shortdot',
          marker: { enabled: true },
          yAxis: 0,
          data: [],
          tooltip: { valueSuffix: ' ' + unit }
        },
      ]
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.buildId === this.props.buildId && nextProps.parentId === this.props.parentId)
      return;
    this.loadNewState(nextProps.parentId, nextProps.buildId);
  }

  render() {
      return (
       <div>
         <div className="row">
           <div className="col-md-6" ref="timeChart"></div>
           <div className="col-md-6" ref="testsChart"></div>
         </div>
         <div className="row">
           <div className="col-md-6" ref="failChart"></div>
           <div className="col-md-6" ref="errorChart"></div>
         </div>
       </div>);
  }
}




// WEBPACK FOOTER //
// ./src/components/LastBuildChart.js